import {createReducer} from '@reduxjs/toolkit'
import {GetWidgetDataResponse} from '@wix/ambassador-events-ui-v1-widget-data/types'

export interface TotalGuestsState {
  totalGuests: GetWidgetDataResponse['totalGuests']
}

const defaultState: TotalGuestsState = {
  totalGuests: {},
}

export const totalGuests = createReducer(defaultState, _builder => {})
